import { Button } from "react-bootstrap";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setScreenView } from '../../slices/commonReducer'


function GridView(props) {
  const { handleIconClick } = props;
  const dispatch = useDispatch()
  const { gridView } = useSelector(state => state.common)


  const handleClick = (val) => {
    dispatch(setScreenView(val))
  }

  return (
    <>
      <Button
        onClick={() => handleClick(gridView === 'list' ? 'grid' : 'list')} 
        className="d-flex align-items-center "
      >
        {gridView === 'list' ? (
          <>
            <i className="ri-layout-grid-line font-size-20 "></i> 
            <span className="fw-bold">Grid</span>
          </>
        ) : (
          <>
            <i className="ri-list-check font-size-20 "></i> 
            <span className="fw-bold">List</span>
          </>
        )}
      </Button>
    </>
  )
}

export default GridView;